import React from "react";
import CompanyService from "../services/company-service";
import { Table } from "components";
import {OrderedMap} from "immutable";
import {Input} from "antd";
import {List} from 'immutable';
const { Search } = Input;

const ANCHOR_LENDER_COLUMNS = new OrderedMap({
    anchor: {
        title: "Anchor Name",
        dataIndex: "company.name",
        key: "anchor"
    },
    lender: {
        title: "Lender",
        dataIndex: "bank.short_name",
        key: "lender"
    }
});

// import { CaseService, CompanyService } from "../../services";
class AnchorLenderMapping extends React.Component {
    state = {
        anchorLenderMappingData : List(),
        currentPage : 1,
        totalCount : 0
    }
    pageSize = 20
    componentDidMount() {
        this.apiCall("" , this.state.currentPage , this.pageSize)
        // CompanyService.getLendingAnchorMappingFilter().then(({data})=>{
        //     console.log('in api resp' , data);
        //     this.setState({
        //         totalCount : data['count'],
        //         anchorLenderMappingData : List(data['results'])
        //     })
        // })
    }


    apiCall = (search , page , pageSize) => {
        console.log('in api call ')
        CompanyService.getLendingAnchorMappingFilter(search , page.toString()  , pageSize.toString() ).then(({data})=>{
            this.setState({

                totalCount : data['count'],
                anchorLenderMappingData : List(data['results'])
            })
        })
    }

     onPageChange = (page, page_size) => {
        this.apiCall("" , page, page_size)
        // this.props.pagination(page, page_size);
        this.setState({currentPage: page});
    };

    onSearch=(str)=>{
        let search = str['search'].toString();
        this.apiCall(search , 1 , this.pageSize)
    }

    onPageSizeChange = (page, pageSize) => {
        this.pageSize = pageSize;
        this.apiCall("" , this.state.currentPage , pageSize);
    }

    render() {
        console.log('anchorLenderMappingData ' , this.state.anchorLenderMappingData)
        return(
            <React.Fragment>
                <Table
                    onFilter={this.onSearch}
                    data={this.state.anchorLenderMappingData}
                    columns={ANCHOR_LENDER_COLUMNS}
                    pagination={{
                                current: this.state.currentPage,
                                showSizeChanger: true,
                                defaultPageSize: this.pageSize,
                                pageSizeOptions: [
                                    "20",
                                    "50",
                                    "100",
                                    "500"
                                ],
                                position: "bottom",
                                total: this.state.totalCount,
                                onChange: (page, pageSize) => this.onPageChange( page, pageSize),
                                onShowSizeChange: this.onPageSizeChange
                            }}
                />
            </React.Fragment>
        );
    }
}


export default AnchorLenderMapping;